import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Order } from '../../classes/Order';
import { OrderService } from '../../services/order.service';
import { CreateOrder } from '../../classes/CreateOrder';
import { RoomService } from '../../services/room.service';
import { Room } from '../../classes/Room';
import { RoomType } from '../../enums/RoomType';
import { BookingOption } from '../../enums/BookingOption';
import { BookingPriceService } from '../../services/booking-price.service';
import { BookingPrice } from '../../classes/BookingPrice';
import { OfficeService } from '../../services/office.service';
import { Office } from '../../classes/Office';
import { LanguageService } from '../../services/language.service';
import { OfficeCouponsService } from 'src/app/services/office-coupons.service';
import { DiscountService } from '../../services/discount.service';
import { OfficeCoupon } from 'src/app/classes/OfficeCoupon';
import { Discount } from '../../classes/Discount';
import { CouponType } from '../../enums/CouponType';
import { UserService } from '../../services/user/user.service';
import { User } from '../../classes/User';
import { UserPolicyConfirmationService } from '../../services/user/user-policy-confirmation.service';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { Subject } from 'rxjs';
import { EventColor } from 'calendar-utils';
import { SlotService } from '../../services/slot.service';
import { TranslateService } from '@ngx-translate/core';

const colors: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#c63a4a',
  },
  green: {
    primary: '#0c5555',
    secondary: '#5ab8b9'
  },
  grey: {
    primary: '#7b7676',
    secondary: '#bbbbb4',
  },
};

@Component({
  selector: 'app-book',
  styleUrls: ['./book.component.scss'],
  templateUrl: './book.component.html',
})
export class BookComponent implements OnInit {

  public bookForm: FormGroup;
  public minDate: NgbDateStruct;
  public errorMessage: string;
  public isError = false;
  public rooms: Room[];
  public roomId: number;
  public bookingPrices: BookingPrice[];
  public bookingOption: BookingOption;
  public BookingOption = BookingOption;
  public slots: string[];
  public office: Office;
  public markDisabled: (date: NgbDate) => boolean;
  public coupon: OfficeCoupon;
  public CouponType = CouponType;
  public userConfirmedDocs: boolean;
  public view: CalendarView = CalendarView.Day;
  public viewDate: Date = new Date();
  public activeDayIsOpen = true;
  public CalendarView = CalendarView;
  public dayStartHour = 0;
  public dayEndHour = 23;
  public monthSubscribe: boolean;
  public userId: number;
  public discounts: Discount[];

  public events: CalendarEvent[] = [];
  public refreshCalendar: Subject<void> = new Subject();
  public hours = [
    '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00',
    '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00',
    '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
  ];
  public startHours = this.hours;
  public endHours = this.hours;
  public hourPeriods = [
    '06:00 - 07:00', '07:00 - 08:00', '08:00 - 09:00', '09:00 - 10:00', '10:00 - 11:00',
    '11:00 - 12:00', '12:00 - 13:00', '13:00 - 14:00', '14:00 - 15:00', '15:00 - 16:00',
    '16:00 - 17:00', '17:00 - 18:00', '18:00 - 19:00', '19:00 - 20:00', '20:00 - 21:00',
    '21:00 - 22:00', '22:00 - 23:00', '23:00 - 00:00'
  ];
  public twoHourPeriods = [
    '06:00 - 08:00', '07:00 - 09:00', '08:00 - 10:00', '09:00 - 11:00', '10:00 - 12:00',
    '11:00 - 13:00', '12:00 - 14:00', '13:00 - 15:00', '14:00 - 16:00', '15:00 - 17:00',
    '16:00 - 18:00', '17:00 - 19:00', '18:00 - 20:00', '19:00 - 21:00', '20:00 - 22:00',
    '21:00 - 23:00', '22:00 - 00:00'
  ];
  public halfsList = ['06:00 - 15:00', '15:00 - 00:00'];
  private addedEvents: CalendarEvent[] = [];
  private readonly officeId: number;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private calendar: NgbCalendar,
              private orderService: OrderService,
              private roomService: RoomService,
              private officeService: OfficeService,
              private couponService: OfficeCouponsService,
              private discountService: DiscountService,
              private bookingPricesService: BookingPriceService,
              private userService: UserService,
              private slotService: SlotService,
              private translateService: TranslateService,
              public languageService: LanguageService,
              public userPolicyService: UserPolicyConfirmationService) {

    this.officeId = activatedRoute.snapshot.params.officeId;
  }

  ngOnInit(): void {

    this.setVisibleHours();

    this.discountService.getAll().subscribe(response => this.discounts = response);

    this.userService.getCurrentUser().subscribe((currentUser: User) => {
      this.userConfirmedDocs = currentUser.confirmed;
      this.userId = currentUser.userId;

      this.bookForm.patchValue({
        confirmed: this.userConfirmedDocs
      });

      this.bookForm.patchValue({
        userId: this.userId
      });

      this.userPolicyService.checkUserPolicy(currentUser.id).subscribe((response: boolean) => {
        this.userConfirmedDocs = response;

        this.bookForm.patchValue({
          confirmed: this.userConfirmedDocs
        });
      });
    });

    this.officeService.officeInfo(this.officeId).subscribe(response => {
      this.office = response;
      if (this.office.city === 'Haifa') {
        this.markDisabled = (date: NgbDate) => this.calendar.getWeekday(date) >= 5 && this.calendar.getWeekday(date) < 7;
      }
    });

    this.roomService.getByOffice(this.officeId).subscribe((response: Room[]) => {
      this.rooms = response;
      this.roomId = this.rooms.find(room => room.type === RoomType.REGULAR).id;
      if (this.roomId) {
        this.bookForm.controls.roomId.setValue(this.roomId);
        this.updateCalendarEvents();
      }
    });

    this.minDate = this.calendar.getToday();

    this.bookForm = this.formBuilder.group({
      roomId: [this.roomId, Validators.required],
      bookingOption: [null, Validators.required],
      startDate: [this.minDate, Validators.required],
      endDate: [this.minDate],
      timeSlot: [''],
      startTime: [''],
      endTime: [''],
      coupon: [''],
      confirmed: [this.userConfirmedDocs],
      monthSubscribe: [this.monthSubscribe],
      userId: [this.userId]
    });

    this.bookForm.controls.bookingOption.valueChanges.subscribe((value) => {
      const date = this.convertNgbDate(this.bookForm.controls.startDate.value, 6, 0, 0, false);
      date.setDate(date.getDate() + this.daysToAdd(value));
      this.bookForm.controls.endDate.setValue(this.convertDate(date));

      if (value === BookingOption.ENTIRE_OFFICE_HOUR) {
        this.slots = this.hourPeriods;
      } else if (value === BookingOption.ONE_SEAT_2HOURS) {
        this.slots = this.twoHourPeriods;
      } else if (value === BookingOption.ENTIRE_OFFICE_HALF_DAY) {
        this.slots = this.halfsList;
      } else {
        this.slots = [];
      }
      this.bookForm.controls.timeSlot.setValue(this.halfsList[0]);
      this.placeEvent();
    });

    this.bookForm.controls.roomId.valueChanges.subscribe((value) => {
      this.bookingPricesService.getByRoom(value).subscribe(response => {
        this.bookingPrices = response;
        this.bookForm.controls.bookingOption.setValue('default');
      });
      this.updateCalendarEvents();
      this.placeEvent();
    });

    this.bookForm.controls.startDate.valueChanges.subscribe((value) => {
      const date = this.convertNgbDate(value, 6, 0, 0, false);
      let daysToAdd = 0;
      if (this.bookForm.controls.bookingOption.value === BookingOption.ONE_SEAT_WEEK) {
        daysToAdd = 6;
      } else if (this.bookForm.controls.bookingOption.value === BookingOption.ONE_SEAT_MONTH) {
        daysToAdd = 30;
      }
      date.setDate(date.getDate() + daysToAdd);
      this.bookForm.controls.endDate.setValue(this.convertDate(date));
      this.viewDate = date;
      this.placeEvent();
    });

    this.bookForm.controls.startTime.valueChanges.subscribe((value) => {
      this.endHours = this.hours.filter(i => i > value || i === '00:00');
      this.placeEvent();
    });

    this.bookForm.controls.endTime.valueChanges.subscribe((value) => {
      this.startHours = this.hours.filter(i => i < value);
      this.placeEvent();
    });

    this.bookForm.controls.timeSlot.valueChanges.subscribe(() => {
      this.placeEvent();
    });
  }

  convertDate(date: Date): NgbDateStruct {
    return date ? {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    } : null;
  }

  convertNgbDate(ngbDate: NgbDateStruct, hours: number, minutes: number, seconds: number, isTransferable: boolean): Date {

    // if hours is 00:00, then set next day

    let day = ngbDate.day;
    if (isTransferable && hours === 0 && minutes === 0) {
      day = ngbDate.day + 1;
    }
    return ngbDate ? new Date(ngbDate.year, ngbDate.month - 1, day, hours, minutes, seconds) : null;
  }

  public bookFormSubmit(): void {

    if (this.bookForm.controls.bookingOption.value === 'default') {
      return;
    }

    if (this.bookForm.controls.timeSlot.value === 'default' &&
      (this.bookForm.controls.bookingOption.value === BookingOption.ONE_SEAT_2HOURS ||
        this.bookForm.controls.bookingOption.value === BookingOption.ENTIRE_OFFICE_HALF_DAY)) {
      return;
    }

    if ((this.bookForm.controls.startTime.value === 'default'
        || this.bookForm.controls.endTime.value === 'default')
      && this.bookForm.controls.bookingOption.value === BookingOption.ENTIRE_OFFICE_HOUR) {
      return;
    }

    const createdOrder = new CreateOrder();
    createdOrder.officeId = this.officeId;
    createdOrder.roomId = this.bookForm.controls.roomId.value;
    createdOrder.bookingOption = this.bookForm.controls.bookingOption.value;
    createdOrder.couponId = this.coupon ? this.coupon.id : null;
    createdOrder.confirmed = this.bookForm.controls.confirmed.value;
    createdOrder.startTime = this.calculateOrderTime(true);
    createdOrder.endTime = this.calculateOrderTime(false);
    createdOrder.workPlaceName = 'ANY';
    createdOrder.monthSubscribe = this.bookForm.controls.monthSubscribe.value ?? false;
    createdOrder.userId = this.bookForm.controls.userId.value;

    this.orderService.createOrder(createdOrder)
      .subscribe({
        next: (order: Order) => {
          this.router.navigate(['booking-confirmation/' + order.id]);
        },
        error: (e) => {
          this.isError = true;
          this.errorMessage = e.error.message;
        },
      });
  }

  public applyCoupon(): void {
    this.couponService.verifyByCode(this.bookForm.controls.coupon.value).subscribe({
      next: (coupon: OfficeCoupon) => {
        if (coupon.bookingOption && coupon.bookingOption !== this.bookForm.controls.bookingOption.value) {
          this.isError = true;
          this.errorMessage = 'This coupon created for another booking option';
        } else {
          this.isError = false;
          this.errorMessage = '';
          this.coupon = coupon;
        }
      },
      error: (e) => {
        this.isError = true;
        this.errorMessage = e.error.message;
        this.bookForm.controls.coupon.setValue(null);
      }
    });
  }

  public closeOpenMonthViewDay(): void {
    this.activeDayIsOpen = false;
  }

  public eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
  }

  public setView(view: CalendarView): void {
    this.view = view;
  }

  placeEvent(): void {

    if (!this.bookForm.controls.bookingOption.value || this.bookForm.controls.bookingOption.value === 'default') {
      return;
    }

    const calendarEvents: CalendarEventAction[] = [];

    const startDate = this.calculateOrderTime(true);
    const endDate = this.calculateOrderTime(false);

    // choose color
    const eventColor = this.getEventColor(startDate, endDate);

    // if event already exists - just modify dates, if not - create the new one
    const isEventExists = this.events.filter(obj => obj.title === 'Your time is here').length > 0;

    if (isEventExists) {
      this.events.filter(obj => obj.title === 'Your time is here').map(event => {
        event.start = startDate;
        event.end = endDate;
        event.color = eventColor;
      });
      this.addedEvents.filter(obj => obj.title === 'Your time is here').map(event => {
        event.start = startDate;
        event.end = endDate;
        event.color = eventColor;
      });
    } else {
      this.events.push({
        title: 'Your time is here',
        start: startDate,
        end: endDate,
        color: eventColor,
        actions: calendarEvents,
        resizable: {
          beforeStart: false,
          afterEnd: false,
        },
        draggable: false,
      });
      this.addedEvents.push({
        title: 'Your time is here',
        start: startDate,
        end: endDate,
        color: eventColor,
        actions: calendarEvents,
        resizable: {
          beforeStart: false,
          afterEnd: false,
        },
        draggable: false,
      });
    }

    this.refreshCalendar.next();
  }

  find(bookingOption: BookingOption): string {
    return this.discounts.map(el => el.bookingOption).includes(bookingOption) ? this.translateService.instant('ADDITIONAL_TEXT.DISCOUNT_TEXT') : '';
  }

  // if selected date is not today - then show day start from 0 hour
  setVisibleHours(): void {
    const today = new Date();
    const isToday = today.toDateString() === this.viewDate.toDateString();
    if (isToday && today.getHours() > 0) {
      this.dayStartHour = today.getHours() - 1;
    } else {
      this.dayStartHour = 0;
    }
  }

  private updateCalendarEvents(): void {
    const selectedDate = this.bookForm.controls.startDate.value;
    const startDate = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.day, 0, 0, 0, 0);
    const endDate = new Date(selectedDate.year, selectedDate.month, selectedDate.day, 0, 0, 0, 0);

    const roomId = this.bookForm.controls.roomId.value;
    this.slotService.getBookedDatePeriodsForRoom(roomId, startDate, endDate).subscribe(
      (data: CalendarEvent[]) => {
        this.events = data;
        this.addedEvents.forEach(ev => this.events.push(ev));
      }
    );
  }

  protected daysToAdd(bookingOption): number {
    let daysToAdd = 0;
    if (bookingOption === BookingOption.ONE_SEAT_WEEK) {
      daysToAdd = 6;
    } else if (bookingOption === BookingOption.ONE_SEAT_MONTH) {
      daysToAdd = 30;
    } else if (bookingOption === BookingOption.ONE_SEAT_QUICK_CARD_5D) {
      daysToAdd = 180;
    } else if (bookingOption === BookingOption.ONE_SEAT_QUICK_CARD_10D) {
      daysToAdd = 180;
    }
    return daysToAdd;
  }

  private calculateOrderTime(isStartTime: boolean): Date {
    let hours = 0;
    const minutes = 0;
    const seconds = 0;
    const selectedBookingOption = this.bookForm.controls.bookingOption.value;

    if (selectedBookingOption === BookingOption.ENTIRE_OFFICE_FULL_DAY ||
      selectedBookingOption === BookingOption.ONE_SEAT_FULL_DAY ||
      selectedBookingOption === BookingOption.ONE_SEAT_WEEK ||
      selectedBookingOption === BookingOption.ONE_SEAT_MONTH ||
      selectedBookingOption === BookingOption.ONE_SEAT_QUICK_CARD_5D ||
      selectedBookingOption === BookingOption.ONE_SEAT_QUICK_CARD_10D) {

      hours = isStartTime ? 6 : 0;
    }

    if (selectedBookingOption === BookingOption.ONE_SEAT_2HOURS || selectedBookingOption === BookingOption.ENTIRE_OFFICE_HALF_DAY) {
      const selectedPeriod = this.bookForm.controls.timeSlot.value;
      hours = isStartTime ? Number(selectedPeriod.substring(0, 2)) : Number(selectedPeriod.substring(8, 10));
    }

    if (selectedBookingOption === BookingOption.ENTIRE_OFFICE_HOUR) {
      hours = isStartTime
        ? Number(this.bookForm.controls.startTime.value.substring(0, 2))
        : Number(this.bookForm.controls.endTime.value.substring(0, 2));
    }

    const selectedDate = isStartTime ? this.bookForm.controls.startDate.value : this.bookForm.controls.endDate.value;

    return this.convertNgbDate(selectedDate, hours, minutes, seconds, !isStartTime);
  }

  protected dateRangeOverlaps(startA: Date, endA: Date, startB: Date, endB: Date): boolean {
    if (startA < startB && startB < endA) {
      return true;
    } // b starts in a
    if (startA < endB && endB < endA) {
      return true;
    } // b ends in a
    if (startB < startA && endA < endB) {
      return true;
    } // a in b
    if (startB < startA && startA < endB) {
      return true;
    } // a starts in b
    if (startB < endA && endA < endB) {
      return true;
    } // a ends in b
    if (startA < startB && endB < endA) {
      return true;
    } // b in a
    if (startA.toISOString() === startB.toISOString()
      && endA.toISOString() === endB.toISOString()) {
      return true;
    } // a equals b
    return false;
  }

  // set visible hours on schedule calendar. if selected date is today, then show day start from now() - 1 hour

  private getEventColor(startDate: Date, endDate: Date): EventColor {
    const isOverlaps =
      this.events
        .filter(event => event.title !== 'Your time is here')
        .filter(event => this.dateRangeOverlaps(startDate, endDate, event.start, event.end))
        .length > 0;

    if (isOverlaps) {
      return colors.red;
    } else {
      return colors.green;
    }
  }
}
